/* Antigravity: Static Vehicle Data */
/* This file governs the "Vehicle Filter" dropdowns. */
/* Format: "Brand": { "years": [start, end], "models": ["List", "Of", "Models"] } */
window.agVehicleData = {
    "Alfa Romeo": {
        "years": [2000, 2024],
        "models": ["147", "156", "159", "Giulietta", "Mito", "Tonale", "Stelvio"]
    },
    "Audi": {
        "years": [2000, 2024],
        "models": ["A1", "A3", "A4", "A5", "A6", "Q2", "Q3", "Q5", "Q7", "TT"]
    },
    "BMW": {
        "years": [2000, 2024],
        "models": ["1 Serisi", "2 Serisi", "3 Serisi", "4 Serisi", "5 Serisi", "X1", "X3", "X5"]
    },
    "Chery": {
        "years": [2008, 2024],
        "models": ["Alia", "Kimo", "Omoda 5", "Tiggo", "Tiggo 7 Pro", "Tiggo 8 Pro"]
    },
    "Chevrolet": {
        "years": [2004, 2023],
        "models": ["Aveo", "Captiva", "Cruze", "Kalos", "Lacetti", "Spark", "Trax"]
    },
    "Citroen": {
        "years": [2000, 2024],
        "models": ["Berlingo", "C-Elysee", "C3", "C3 Aircross", "C4", "C4 Cactus", "C4 Picasso", "C5", "C5 Aircross", "Nemo"]
    },
    "Dacia": {
        "years": [2004, 2024],
        "models": ["Dokker", "Duster", "Jogger", "Lodgy", "Logan", "Sandero", "Spring"]
    },
    "Fiat": {
        "years": [2000, 2024],
        "models": ["Albea", "Bravo", "Doblo", "Egea", "Fiorino", "Grande Punto", "Linea", "Palio", "Panda", "Punto", "Punto Evo"]
    },
    "Ford": {
        "years": [2000, 2024],
        "models": ["B-Max", "C-Max", "Connect", "Courier", "Custom", "EcoSport", "Fiesta", "Focus", "Fusion", "Kuga", "Mondeo", "Mustang", "Puma", "Ranger", "Transit"]
    },
    "Honda": {
        "years": [2000, 2024],
        "models": ["Accord", "City", "Civic", "CR-V", "HR-V", "Jazz"]
    },
    "Hyundai": {
        "years": [2000, 2024],
        "models": ["Accent", "Accent Blue", "Accent Era", "Bayon", "Elantra", "Getz", "i10", "i20", "i30", "ix35", "Kona", "Staria", "Tucson"]
    },
    "Kia": {
        "years": [2004, 2024],
        "models": ["Ceed", "Cerato", "Niro", "Picanto", "Rio", "Sorento", "Sportage", "Stonic", "Xceed"]
    },
    "Mercedes": {
        "years": [2000, 2024],
        "models": ["A Serisi", "B Serisi", "C Serisi", "CLA", "E Serisi", "GLA", "GLB", "GLC", "Vito", "Sprinter"]
    },
    "Nissan": {
        "years": [2004, 2024],
        "models": ["Juke", "Micra", "Navara", "Note", "Qashqai", "X-Trail"]
    },
    "Opel": {
        "years": [2000, 2024],
        "models": ["Astra F", "Astra G", "Astra H", "Astra J", "Astra K", "Astra L", "Corsa C", "Corsa D", "Corsa E", "Corsa F", "Crossland", "Grandland X", "Insignia", "Meriva", "Mokka", "Vectra C", "Zafira"]
    },
    "Peugeot": {
        "years": [2000, 2024],
        "models": ["107", "2008", "206", "207", "208", "3008", "301", "307", "308", "407", "5008", "508", "Bipper", "Partner", "Rifter"]
    },
    "Renault": {
        "years": [2000, 2024],
        "models": ["Austral", "Captur", "Clio 2", "Clio 3", "Clio 4", "Clio 5", "Fluence", "Kadjar", "Kangoo", "Laguna", "Latitude", "Master", "Megane 1", "Megane 2", "Megane 3", "Megane 4", "Modus", "Scenic", "Symbol", "Taliant", "Trafic", "Twingo"]
    },
    "Seat": {
        "years": [2000, 2024],
        "models": ["Arona", "Ateca", "Cordoba", "Ibiza", "Leon", "Toledo"]
    },
    "Skoda": {
        "years": [2000, 2024],
        "models": ["Fabia", "Kamiq", "Karoq", "Kodiaq", "Octavia", "Rapid", "Scala", "Superb", "Yeti"]
    },
    "Tofas": {
        "years": [1990, 2002],
        "models": ["Dogan", "Kartal", "Sahin"]
    },
    "Toyota": {
        "years": [2000, 2024],
        "models": ["Auris", "Avensis", "C-HR", "Corolla", "Corolla Cross", "Hilux", "Proace", "RAV4", "Yaris", "Yaris Cross"]
    },
    "Volkswagen": {
        "years": [2000, 2024],
        "models": ["Amarok", "Arteon", "Bora", "Caddy", "Caravelle", "Crafter", "Golf 4", "Golf 5", "Golf 6", "Golf 7", "Golf 8", "Jetta", "Passat B5", "Passat B6", "Passat B7", "Passat B8", "Polo", "Scirocco", "T-Cross", "T-Roc", "Taigo", "Tiguan", "Touareg", "Touran", "Transporter"]
    },
    "Volvo": {
        "years": [2004, 2024],
        "models": ["S40", "S60", "S90", "V40", "XC40", "XC60", "XC90"]
    }
};
